export default __webpack_public_path__ + "static/media/print-logo-invoice.ee42ca61.png";